import axios from 'axios';

export async function downloadJSON<T>(assetPath: string): Promise<T> {
  const { data } = await axios.get<T>(assetPath);
  return data;
}
